import { UseCustomAxios } from "../../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../../util/Utils";

export function UseFooterCertificates() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateCertificate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);
    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات گواهینامه را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetFooterCertificates = (FooterId, callback) => {
    MyAxios.get(`Admin_HomePage/GetFooterCertificates/${FooterId}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const SetFooterCertificates = (state, image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (image) {
      data.append("image", image);
    }
    MyAxios.post(`Admin_HomePage/SetFooterCertificates`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("با موفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const RemoveFooterCertificates = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_HomePage/RemoveFooterCertificates`, {
      data: data,
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("گواهینامه با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    GetFooterCertificates,
    SetFooterCertificates,
    RemoveFooterCertificates,
    validateCertificate,
  };
}
